import { useEffect, useState } from 'react';

/**
 * Live-updating `prefers-reduced-motion: reduce`.
 *
 * Extracts the inline `matchMedia` pattern repeated across EvieOrb / MenuIcon /
 * TokenSpin into one shared hook so motion surfaces (the guided tour, etc.)
 * read a single source of truth and re-render when the OS preference flips.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mql.matches);
    const handler = (e: MediaQueryListEvent) => setReduced(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);
  return reduced;
}
